import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setAdditionalKeys, updateAuthorCollections } from './PublicPageDataSlice';

interface ApiState {
  collections: any;
  pagination : any;
  loading: any;
  error: string | null;

  // page:any;
  // status:any;
}

const initialState: ApiState = {
  collections: [],
  pagination : {},
  loading: false,
  error: null,
  // page:1,
  // status:null,
};


export const fetchAuthorCollections = createAsyncThunk(
  'authorCollections/fetchAuthorCollections',
  async ( {page, authorId}:any, { getState, dispatch, rejectWithValue }) => {
    const newPage = page === 0 ? 1 : page;

    try {
      const config:any = {
        headers: {
          Authorization: (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
        },
        credentials: 'omit', // or 'same-origin' or 'include' based on your needs
      };

      const queryParams = new URLSearchParams();
      if (newPage) queryParams.append('page', newPage);
      if (authorId) queryParams.append('author', authorId);
      // if (status !== 'all' && status !== null) queryParams.append('status', status);
    //   if (search) queryParams.append('search', search);

      const response = await fetch(`https://www.notablehq.com/wp-json/nhq/v1/collections/list/?${queryParams}`, config);

      if (!response.ok) {
        const error = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}. Message: ${error}`);
      }

      const data = await response.json();
      dispatch(setAdditionalKeys(data?.collections))
      return data;
    } catch (error) {
      console.error('Error fetching author collections:', error);
      throw error;
    }
  }
);


const authorCollectionsSlice = createSlice({
  name: 'authorCollections',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthorCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuthorCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.collections = action.payload?.collections;
        state.pagination = action.payload?.pagination;
      })
      .addCase(fetchAuthorCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch data';
      })

  },
});

export default authorCollectionsSlice.reducer;
export const {  } = authorCollectionsSlice.actions;
// export { fetchUserCollections };
